
import { Component, Vue, Watch } from "vue-property-decorator";
import Restaurant from "../../domain/restaurant/Restaurant";
import RestaurantCard from "@/components/restaurant/RestaurantCard.vue";
@Component({
  components: { RestaurantCard }
})
export default class RestaurantList extends Vue {
  restaurants: Restaurant[] = [];
  constructor() {
    super();
    this.restaurants = this.$store.getters.getRestaurantList;
  }

  mounted() {
    this.restaurants.sort(Restaurant.RestaurantsByNameAscendingComparator);
  }

  @Watch("restaurantList")
  updateRestaurantList() {
    this.restaurants = this.restaurantList;
  }

  get restaurantList() {
    return this.$store.getters.getRestaurantList;
  }

  get hasRestaurants() {
    return this.restaurantList.length > 0;
  }

  addNewRestaurant(newRestaurant: Restaurant) {
    this.restaurants.push(newRestaurant);
    this.restaurants.sort(Restaurant.RestaurantsByNameAscendingComparator);
  }

  removeRestaurant(toRemove: Restaurant) {
    const indexToRemove = this.restaurants.indexOf(toRemove);
    if (indexToRemove > -1) {
      this.restaurants.splice(indexToRemove, 1);
    }
  }

  get isAdmin() {
    console.log(this.$store.getters.isAdmin);
    return this.$store.getters.isAdmin;
  }
}
